// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Loader_spinnerContainer__f9vH7","noPaddingSpinner":"Loader_noPaddingSpinner__jAIeM","lottieWrapper":"Loader_lottieWrapper__G5Kfw","lottie":"Loader_lottie__EBZAk"};